export default __webpack_public_path__ + "rn-ios@2x.png";